// `/deals/:preDealId/edit`. With the deal flow off, the form that edits a deal (DealForm.jsx). With
// it on (TX-US-0043), a deal's fields are edited on its page, beside what its next move waits on,
// so the address leads there.

import { Navigate, useParams } from 'react-router';

import { useMe } from '../MeContext.js';
import DealForm from './DealForm.jsx';
import { flowOn } from './flow.js';

export default function DealEditRoute() {
  const { preDealId } = useParams();
  if (flowOn(useMe())) return <Navigate to={`/deals/${preDealId}`} replace />;
  return <DealForm mode="edit" />;
}
